const photoLabel = count => {
  if (count < 1) return "画像を選択（3枚まで）";
  if (count < 3) return `画像を選択（${count}枚選択済み・あと${3 - count}枚）`;

  return "画像を選択（3枚選択済み・次の選択で1枚目を変更）";
};

export const setDroppedPhotos = (inputs, files, DataTransferClass = DataTransfer) => {
  if (!DataTransferClass) return 0;

  const selectedFiles = [...files].slice(0, inputs.length);

  inputs.forEach(input => {
    input.value = "";
  });

  selectedFiles.forEach((file, index) => {
    const transfer = new DataTransferClass();

    transfer.items.add(file);
    inputs[index].files = transfer.files;
    inputs[index].dispatchEvent(new Event("change", { bubbles: true }));
  });

  return selectedFiles.length;
};

export const initContactPhotos = (root = document) => {
  const areas = [...root.querySelectorAll("[data-contact-photos]")];
  const cleanups = areas.map(area => {
    const trigger = area.querySelector("[data-contact-photo-trigger]");
    const inputs = [...area.querySelectorAll('input[type="file"]')];

    if (!trigger || !inputs.length) return () => {};

    const sync = () => {
      const count = inputs.filter(input => input.files?.length).length;

      trigger.setAttribute("aria-label", photoLabel(count));
    };

    const click = () => {
      const nextInput = inputs.find(input => !input.files?.length) || inputs[0];

      nextInput.click();
    };

    const dragover = event => {
      event.preventDefault();
    };

    const drop = event => {
      event.preventDefault();
      setDroppedPhotos(inputs, event.dataTransfer?.files || []);
      sync();
    };

    trigger.addEventListener("click", click);
    trigger.addEventListener("dragover", dragover);
    trigger.addEventListener("drop", drop);
    inputs.forEach(input => input.addEventListener("change", sync));
    document.addEventListener("wpcf7reset", sync);
    sync();

    return () => {
      trigger.removeEventListener("click", click);
      trigger.removeEventListener("dragover", dragover);
      trigger.removeEventListener("drop", drop);
      inputs.forEach(input => input.removeEventListener("change", sync));
      document.removeEventListener("wpcf7reset", sync);
    };
  });

  return () => cleanups.forEach(cleanup => cleanup());
};

if (typeof document !== "undefined" && typeof window !== "undefined") {
  initContactPhotos();
}
